export default __webpack_public_path__ + "static/media/fact_sheet39.378f4783.png";